import { create } from 'zustand'

type FormStoreProps = {
  params: any
  setParams: (arg: any) => void
}
const useFormStore = create<FormStoreProps>((set) => ({
  params: {},
  setParams: (args) => {
    set(() => ({ params: { ...args } }))
  },
}))
export default useFormStore
